import { createSelector } from 'reselect';

const selectCards = (state: any) => state.cards;


export const selectCurrentItem = createSelector([selectCards], (cards) => cards.current);

export const selectCardListItems = createSelector([selectCards], (cards) => cards.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectCardListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCardQueryItems = createSelector([selectCards], (cards) => cards.query);

export const selectCreatedItem = createSelector([selectCards], (cards) => cards.create);

export const selectUpdatedItem = createSelector([selectCards], (cards) => cards.update);

export const selectReadItem = createSelector([selectCards], (cards) => cards.read);

export const selectDeletedItem = createSelector([selectCards], (cards) => cards.delete);

export const selectSearchedItems = createSelector([selectCards], (cards) => cards.search);

export const selectItemsCount = createSelector([selectCards], (cards) => cards.count);

export const selectItemsFilter = createSelector([selectCards], (cards) => cards.filter);